import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import SiteRender from "@/components/diy/SiteRender";

export const draftKey = (pid) => `diy-preview-${pid}`;

export default function SitePreview() {
  const { pid } = useParams();
  const embed = new URLSearchParams(window.location.search).get("embed") === "1";
  const [d, setD] = useState(null); const [err, setErr] = useState(null); const [pg, setPg] = useState(0);
  useEffect(() => {
    const read = () => { try { const x = JSON.parse(localStorage.getItem(draftKey(pid)) || "null"); if (x?.site) { setD(x); setPg(x.page || 0); return true; } } catch (e) { /* ignore bad draft */ } return false; };
    if (!read()) {
      Promise.all([api.get(`/diy-sites/${pid}`), api.get(`/diy-sites/${pid}/library`)])
        .then(([s, l]) => s.data.site ? setD({ site: s.data.site, setup: s.data.setup, media: Object.fromEntries(l.data.map((a) => [a.id, { url: a.file_url, type: a.media_type }])) }) : setErr("Generate your website first."))
        .catch((e) => setErr(errMsg(e)));
    }
    const on = (e) => { if (e.key === draftKey(pid)) read(); };
    window.addEventListener("storage", on);
    return () => window.removeEventListener("storage", on);
  }, [pid]);
  useEffect(() => { if (d && !embed) document.title = `Preview - ${d.setup?.brand?.company || d.site.pages[0]?.title || "Website"}`; }, [d, embed]);
  if (err) return <div className="p-10 text-center text-slate-600" data-testid="site-preview-error">{err}</div>;
  if (!d) return <div className="p-10 text-center text-slate-500" data-testid="site-preview-loading">Loading preview…</div>;
  return (
    <div className="min-h-screen bg-white" data-testid="site-preview">
      {!embed && <div className="sticky top-0 z-50 bg-amber-100 text-amber-900 text-xs text-center py-1.5" data-testid="site-preview-banner">Preview only · not public until you publish · enquiries are disabled here</div>}
      <SiteRender key={pg} site={d.site} setup={d.setup} media={d.media} initialPage={pg} />
    </div>
  );
}
